export default __webpack_public_path__ + "static/media/logo.c1c8e700.svg";